<div class="tour-title-wrapper">
    <span multilang class="tour-title">{{'Zimmertyp'}}</span>
</div>

<ng-container *ngTemplateOutlet="roomTypeListEx?.length > 0 ? extern : all"></ng-container>

<ng-template #extern>
    <div class="tour-wrapper">
        <ng-container *ngFor="let item of roomTypeListEx | slice:0:slicenbr">
            <button class="tour-item-wrapper-ext" (click)="selected(item)" matRipple>
                <mat-icon class="tour-item-icon ">{{selectedList.indexOf(item.code) >= 0 ? 'check_box' :
                    'check_box_outline_blank'}}</mat-icon>
                <div class="bestprc">
                    <span multilang class="tour-item-name-ext">{{item.name}}</span>
                    <span multilang class="bestprcit">ab {{item.bestPricePerPerson?.value + ' ' +
                        item.bestPricePerPerson?.currency}} p.P.</span>
                </div>
            </button>
        </ng-container>
        <ng-container *ngIf="roomTypeListEx.length > 5">
            <ng-container *ngIf="(slicenbr < roomTypeListEx.length) else less">
                <button class="showallbtn" (click)="showMore(roomTypeListEx.length)" matRipple>
                    <span multilang>{{'alle'}} {{roomTypeListEx.length}} {{'anzeigen'}}</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span multilang>{{'weniger anzeigen'}}</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
</ng-template>

<ng-template #all>
    <div class="tour-wrapper" *ngIf="roomTypeList?.length > 0">
        <ng-container *ngFor="let op of roomTypeList| slice:0:slicenbr">
            <button class="tour-item-wrapper" (click)="selected(op)" matRipple>
                <mat-icon class="tour-item-icon ">{{selectedList.indexOf(op.code) >= 0 ? 'check_box' :
                    'check_box_outline_blank'}}</mat-icon>
                <span multilang class="tour-item-name">{{op.name}}</span>
            </button>
        </ng-container>
        <ng-container *ngIf="roomTypeList.length > 5">
            <ng-container *ngIf="(slicenbr < roomTypeList.length) else less">
                <button class="showallbtn" (click)="showMore(roomTypeList.length)" matRipple>
                    <span multilang>{{'alle'}} {{roomTypeList.length}} {{'anzeigen'}}</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span multilang>{{'weniger anzeigen'}}</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
</ng-template>